import request from '@/utils/request'

export function getUserInfo(data) {
  return request({
    url: '/api/user',
    method: 'get',
    data
  })
}